import { ContributorDoc } from "@input-output-hk/essential-cardano-models";
import { Jsonified } from "../data/db/jsonify";
import { Maybe } from "./types";
import { UserProfile } from "@auth0/nextjs-auth0";

export type SourceUser = UserProfile & { _id: string };
export type OtherUser = Pick<Jsonified<ContributorDoc>, "_controllingUserId">;

export function isMe(
  user: Maybe<Pick<SourceUser, "_id">>,
  otherUser: Maybe<OtherUser>
) {
  if (user?._id && user?._id === otherUser?._controllingUserId) {
    return true;
  }
  return false;
}
